import { render, staticRenderFns } from "./AddCatalogDialog.html?vue&type=template&id=0e56e962&"
import script from "./AddCatalogDialog.js?vue&type=script&lang=js&"
export * from "./AddCatalogDialog.js?vue&type=script&lang=js&"
import style0 from "./AddCatalogDialog.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports